module.exports = __webpack_public_path__ + "assets/img/flow.a0ec7608.png";